module.exports = __webpack_public_path__ + "img/icon_shop_02.4d5d89c0.png";